const links = [
  { id: 'shifts', label: 'Shifts' },
  { id: 'lifecycle', label: 'Lifecycle' },
  { id: 'architecture', label: 'Architecture' },
  { id: 'risks', label: 'Risks' },
  { id: 'framework', label: 'SHIFT' },
];

export default function StickyNav() {
  return (
    <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-bg/70 border-b hairline">
      <div className="mx-auto max-w-6xl px-6 h-14 flex items-center justify-between">
        <a href="#" className="font-display tracking-tight2 text-lg">
          SHIFT<span className="text-accent">.</span>
        </a>
        <ul className="hidden md:flex gap-8 text-sm text-ink-dim">
          {links.map((l) => (
            <li key={l.id}>
              <a className="hover:text-ink transition-colors" href={`#${l.id}`}>
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
